import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_URL } from 'seo/seoConfig';

export default function SeoBreadcrumbs({ mode, keyword }) {
  if (!keyword && mode !== 'tarot') return null;

  const crumbs = [{ label: 'Hotto', href: '/' }];

  if (mode === 'tarot') {
    crumbs.push({ label: 'ไพ่ยิปซี', href: '/tarot' });
  } else if (mode === 'dream') {
    crumbs.push({
      label: `ทำนายฝัน: ${keyword}`,
      href: `/search/${encodeURIComponent(keyword)}`,
    });
  } else if (mode === 'number') {
    crumbs.push({
      label: `สถิติเลข ${keyword}`,
      href: `/search/${encodeURIComponent(keyword)}`,
    });
  }

  return (
    <nav className="seo-breadcrumbs" aria-label="เส้นทางนำทาง">
      <ol
        className="seo-breadcrumbs__list"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          const absolute = `${SITE_URL}${crumb.href === '/' ? '/' : crumb.href}`;

          return (
            <li
              key={crumb.href}
              className="seo-breadcrumbs__item"
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {isLast ? (
                <span itemProp="name">{crumb.label}</span>
              ) : (
                <Link to={crumb.href} itemProp="item">
                  <span itemProp="name">{crumb.label}</span>
                </Link>
              )}
              <meta itemProp="position" content={String(index + 1)} />
              {!isLast && <meta itemProp="item" content={absolute} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
